import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { isAnalystSurveillance } from 'utils/auth'
import { useSessionState } from 'contexts/Session'

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { currentUser } = useSessionState()

  if (!Component) {
    return <div />
  }

  return (
    <Route
      {...rest}
      render={props =>
        isAnalystSurveillance(currentUser) ? (
          <Redirect to={{ pathname: '/surveillance', state: { from: props.location } }} />
        ) : (
          <Component {...props} />
        )
      }
    />
  )
}

export default PrivateRoute
